require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-eisenstadt-und-umgebung-steinbrunn.json") })
        }
      }, "path---betreuungseinrichtungen-eisenstadt-und-umgebung-steinbrunn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-eisenstadt-und-umgebung-steinbrunn!./.cache/json/betreuungseinrichtungen-eisenstadt-und-umgebung-steinbrunn.json
// module id = 873
// module chunks = 231608221292675